import { NODE_TYPES } from '../../config/caf';
import { RuleExecutionContext, ResponseObj } from '../../types/caf';
import { GlobalState } from '../../types/common';

const OutputProcessor = {
  processResponse: function (rawOpt: {
    context: RuleExecutionContext;
    response: ResponseObj[];
    globalContext: GlobalState;
  }): ResponseObj[] {
    const { context, response: responseList, globalContext } = rawOpt;

    return responseList.map((node) => {
      const formattedNode = { ...node };

      switch (node.type) {
        case NODE_TYPES.TEXT:
          formattedNode.value = globalContext.i18n.getText(node.value, context);

          return formattedNode;

        case NODE_TYPES.IMAGE_OPTIONS:
          formattedNode.value = node.isDynamic ? context.value : node.value;

          return formattedNode;

        case NODE_TYPES.BUBBLE_OPTIONS:
          formattedNode.value = node.isDynamic ? context.value : node.value;

          return formattedNode;
        case NODE_TYPES.BUTTON_OPTIONS:
          formattedNode.value = node.isDynamic ? context.value : node.value;

          return formattedNode;

        default:
          return null;
      }
    });
  }
};

export default OutputProcessor;
